import { apiClient } from "./api";
import type {
  AnchorMemberCenterMonthlySummary,
  AnchorInstagramSaveRequest,
  AnchorPrivateImagesSaveRequest,
  AnchorPrivateVideosSaveRequest,
  AnchorProfileResponse,
  AnchorProfileSaveRequest,
  AnchorSettlementRecord,
  AnchorWithdrawCreateRequest,
  AnchorWithdrawCreateResponse,
  AnchorWithdrawPrepare,
  AnchorUploadedFile,
  VideoFrameModerationUploadRequest,
  VideoFrameModerationUploadResponse,
} from "@/types";

export const anchorApi = {
  getProfile() {
    return apiClient.get<AnchorProfileResponse>("/me");
  },
  saveProfile(payload: AnchorProfileSaveRequest) {
    return apiClient.put<AnchorProfileResponse>("/profile", payload);
  },
  saveInstagram(payload: AnchorInstagramSaveRequest) {
    return apiClient.put<AnchorProfileResponse>("/profile/instagram", payload);
  },
  savePrivateImages(payload: AnchorPrivateImagesSaveRequest) {
    return apiClient.put<AnchorProfileResponse>(
      "/profile/private-images",
      payload,
    );
  },
  savePrivateVideos(payload: AnchorPrivateVideosSaveRequest) {
    return apiClient.put<AnchorProfileResponse>(
      "/profile/private-videos",
      payload,
    );
  },
  uploadProfileImage(file: File) {
    return apiClient.uploadToBackend<AnchorUploadedFile>("/files/upload", file, {
      upload_source: "anchor-profile",
      media_kind: "image",
    });
  },
  uploadProfileVideo(file: File) {
    return apiClient.uploadToBackend<AnchorUploadedFile>("/files/upload", file, {
      upload_source: "anchor-profile",
      media_kind: "video",
    });
  },
  uploadModerationFrameImage(file: File, options?: RequestInit) {
    return apiClient.uploadSilently<AnchorUploadedFile>(
      "/files/upload",
      file,
      {
        upload_source: "video-frame-moderation",
      },
      options,
    );
  },
  uploadModerationFrame(
    orderID: string,
    payload: VideoFrameModerationUploadRequest,
    options?: RequestInit,
  ) {
    return apiClient.postSilently<VideoFrameModerationUploadResponse>(
      `/orders/${encodeURIComponent(orderID)}/moderation-frames`,
      payload,
      options,
    );
  },
  getMemberCenterMonthlySummary() {
    return apiClient.get<AnchorMemberCenterMonthlySummary>(
      "/member-center/monthly-summary",
    );
  },
  getSettlementRecords(params?: { page?: number; page_size?: number }) {
    return apiClient.getPaginated<AnchorSettlementRecord>(
      "/member-center/settlement-records",
      params,
    );
  },
  getWithdrawPrepare() {
    return apiClient.get<AnchorWithdrawPrepare>(
      "/member-center/withdraw-prepare",
    );
  },
  createWithdrawRequest(payload: AnchorWithdrawCreateRequest) {
    return apiClient.post<AnchorWithdrawCreateResponse>(
      "/member-center/withdraw-requests",
      payload,
    );
  },
};
